// extracted by mini-css-extract-plugin
export var menuIcon = "_uh-0";
export var menuIconInline = "_uh-1";